<template>
	<div class="full" style="overflow: auto;">
		<datacenter />
	</div>
</template>
<style scoped>

</style>
<script>
	import datacenter from '@/views/datacenter/index'
	export default {
		name: 'datacenterIndex',
		props: {

		},
		data() {
			return {

			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			datacenter
		}
	}
</script>
